// ------------------------------------
// Inicializa os Contadores
// ------------------------------------

// Inicia o contador
$(function () {
  initCountdowns();
});

function initCountdowns() {
  $('.countdown').each(function () {
    initCountdown($(this));
  });
}

function initCountdown($el) {
  const $countdownEl = $el;
  if ($countdownEl.length > 0) {
    const mode = $countdownEl.data('mode');
    const minutes = $countdownEl.data('minutes');
    const date = $countdownEl.data('date');
    let futureDate;
    if (mode === 'date') {
      futureDate = new Date(date);
    } else if (mode === 'minutes') {
      futureDate = new Date();
      futureDate.setMinutes(new Date().getMinutes() + Number(minutes));
    }
    if ($countdownEl[0]._countdown) {
      $countdownEl[0]._countdown.destroy();
      $countdownEl[0]._countdown = null;
    }
    $countdownEl[0]._countdown = new Countdown(futureDate, $countdownEl);
  }
}
